export default angular.module('ApiUtils.lab.external', [
    'ApiUtils.lab.external.pepsiCo'
]);